import { useMemo } from 'react';
import { RouterLink } from '@redux-first-router-link';

import { Grid, Box, Heading, Text, Button } from '@simplywallst/ui-core';
import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';

import type { Portfolios as PortfoliosType } from '@/hooks/portfolio/usePortfolio';

import DeferRenderUntilIntersecting from '@/components/DeferRenderUntilIntersecting';

import { ROUTE_PORTFOLIO_NEW } from '@/constants/routes';
import { PortfolioCard } from '../PortfolioCard';

type Props = {
  portfolios: PortfoliosType;
};

export const Portfolios = ({ portfolios }: Props) => {
  const sortedPortfolios = useMemo(
    () =>
      [...portfolios].sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
      ),
    [portfolios]
  );

  return (
    <Box
      data-cy-id="portfolios-section"
      marginY="x0"
      marginXLg="x0"
      marginX="x2"
    >
      <Grid templateRows="auto auto">
        <Grid
          templateColumns="repeat(2, auto)"
          justifyContent="start"
          alignItems="center"
          gap="8px"
          gapLg="16px"
        >
          <Grid
            templateColumns="repeat(2, max-content)"
            alignItems="center"
            gap="4px"
          >
            <Heading as="h3" typography="baseStrong">
              Portfolios
            </Heading>
            <Grid
              templateRows="24px"
              templateColumns="24px"
              backgroundColor="phantom"
              borderRadius="x2"
              justifyItems="center"
              alignItems="center"
            >
              <Text typography="xSmall">{portfolios.length}</Text>
            </Grid>
          </Grid>
          <RouterLink to={{ type: ROUTE_PORTFOLIO_NEW }}>
            <Button styleType="passive" alignIcon="left" onClick={() => {}}>
              <PlusSolid fill="white" /> New portfolio
            </Button>
          </RouterLink>
        </Grid>
        <Box marginTop="x2">
          <Grid
            gap="24px"
            templateRows="auto"
            templateColumnsXl="repeat(3, 368px)"
            templateColumnsMd="repeat(2, 1fr)"
            templateColumns="1fr"
            justifyContentMd="space-between"
            justifyContent="center"
          >
            {sortedPortfolios.map((portfolio) => (
              <DeferRenderUntilIntersecting
                key={portfolio.id}
                preRenderHeight={248}
              >
                <PortfolioCard portfolioId={portfolio.id} />
              </DeferRenderUntilIntersecting>
            ))}
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};
